// SimplePassword.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useRef, useEffect } from 'react';
import { Input } from 'antd';
import { useSimpleFormContext } from './SimpleFormProvider';
import SimpleFormItem from './SimpleFormItem';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { useModuleContext } from 'components/core/ModuleProvider';
import useFormElement from 'hooks/useFormElement';
import useCustomValidationStatus from 'hooks/useCustomValidationStatus';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************

// *******************************************************************************
// FUNCTIONS
// *******************************************************************************

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const SimplePassword = ({
  name,
  subdocumentField,
  style = {},
  styleItem = {},
  onBlur,
  useInitialInAvatar,
  disabled = false,
  prefix,

  minLength,
  maxLength,

  ...props
}) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { locked, disabledFields } = useSimpleFormContext();
  // const { setFunctions, documentDuplicated } = useModuleContext();

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────
  const elementProps = useFormElement(name, subdocumentField);
  const { elementRef, fullFieldName, flattenFieldName } = elementProps;
  const { customValidationStatus, customValidationMessage, handleChange } =
    useCustomValidationStatus({ ...props, ...elementProps });

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const isDisabled = disabled || locked || disabledFields?.includes(flattenFieldName);

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <SimpleFormItem
      {...props}
      name={fullFieldName}
      elementProps={elementProps}
      customValidationStatus={customValidationStatus}
      customValidationMessage={customValidationMessage}
      style={styleItem}
    >
      <Input.Password
        ref={elementRef}
        id={flattenFieldName}
        style={style}
        onBlur={onBlur}
        onChange={handleChange}
        disabled={isDisabled}
        prefix={prefix}
        minLength={minLength}
        maxLength={maxLength}
      />
    </SimpleFormItem>
  );
};

export default SimplePassword;
